import React from 'react'
import { useLottie } from "lottie-react";
import TestLoader from './test.json';
const SearchLottie = () => {
    const options = {
        animationData: TestLoader,
        loop: true
    };

    const { View } = useLottie(options);

    return <center><div style={{ width: '300px', height: "40vh", display: 'flex', alignItems: 'center' }}  >{View}</div></center>;
}

export default SearchLottie